export default {
	name: 'Remote',
	friendly_name: 'Remote',
	family: 'remote',
	isPM: false,
	availableViews: ['basic'],
	modes: [],
	control_holder: 0,
	settings: [{ title: 'not_ready' }],
};
